import React, { useState } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

const Product = (props) => {
    const [featuredItems, setFeaturedItems] = useState(props.containerObject && props.containerObject.results ? props.containerObject.results : "")
    const [containerObject, setContainerObject] = useState(props.containerObject ? props.containerObject : "");

    const handleQuickViewProductPage = (event) => {
        event.preventDefault()
        var formData = new FormData(event.target);
        const productId = formData.get("productIdss")
        const productCount = formData.get("productCount")
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/product/product-quick-view/${productId}`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                if (res !== null) {
                    //setIsLoading(false)
                    //	setProductDetailsView(res)
                    var productDetatils = (JSON.parse(res.response)).response
                    //props.productDetailsCallBack(productDetatils)
                    //	props.productCountCallBack(productCount ? productCount : "")
                    document.getElementById("hiddenSharePageModal").click()
                } else {
                    //setIsLoading(false)
                    //const error = res._ERROR_MESSAGE_;
                    //setErrorMessage(error);
                    //document.getElementById("login-message-error-div").classList.remove("d-none");
                    // console.log("errorMessage ---->>>>!!!!", errorMessage)
                }
            })
    }
  return (
    <>
        {featuredItems ? featuredItems.map(featuredItem => {
              return (
                <>
                  <div class={`${containerObject && containerObject.attributes && containerObject.attributes.colPerRowSizeForGridView ? containerObject.attributes.colPerRowSizeForGridView : "col-6 col-md-3"}`}>
                    <div class="qv-model"  >
                      <Link to={featuredItem["productUrl"]} class="c-product-link">
                        <img fetchpriority="high" alt="Insect Display Case" src={`https://www.carolina.com${featuredItem["product.smallImageUrl"]}` ? `https://www.carolina.com${featuredItem["product.smallImageUrl"]}` : ""} class="c-product-img" />
                        <h3 class="cb-product-title featured-product-title" dangerouslySetInnerHTML={{ __html: featuredItem["product.productName"] ? featuredItem["product.productName"] : "" }}>
                        </h3>
                      </Link>
                      <div className="">
                        {featuredItem["product.familyProduct.count"] ? <p class="c-product-total">{featuredItem["product.familyProduct.count"] ? featuredItem["product.familyProduct.count"] : ""}&nbsp; products</p> : featuredItem["product.productId"] ? <p class="c-product-total featured-product-id">Item #{featuredItem["product.productId"] ? featuredItem["product.productId"] : ""}</p> : ""}
                        <p class="c-product-price">
                          {featuredItem.itemPrice ? featuredItem.itemPrice : ""}
                        </p>
                      </div>
                      <div class="c-product-rating">
                      </div>
                      <Link id="hiddenSharePageModal" aria-current="page" data-bs-toggle="modal" data-bs-target="#quickViewModal"></Link>
                      <form onSubmit={handleQuickViewProductPage} className="" id={`quickViewModalForm${props.indexValue}`}>
                        <input type="hidden" name="productIdss" value={featuredItem["product.productId"]} id={`productObj${props.indexValue}`} />
                        <input type="hidden" name="productCount" value={featuredItem["product.familyProduct.count"] ? featuredItem["product.familyProduct.count"] : ""} id={`productObj${props.indexValue}`} />
                        <button type="submit" className="btn quick-btn modal-link" >Quick View</button>
                      </form>
                    </div>
                  </div>

                </>
              )
            }) : ""}
    </>
  )
}

export default Product